import React from 'react';
import { TransportationOrderDataForm } from '../../../../app/models/TransportationOrder';

interface Props {
    transportationOrder: TransportationOrderDataForm;
}

const TransportationOrderBillingTab = ({ transportationOrder }: Props) => {
    const hasStandardWeight = Boolean(transportationOrder.use_standard_weight);

    const formatWeight = (value?: number | string | null, unit?: string | null) => {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        const numericValue = Number(value);
        const isValidNumber = !Number.isNaN(numericValue);
        const displayValue = isValidNumber
            ? numericValue.toLocaleString('es-CL', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 4
              })
            : String(value);

        return unit ? `${displayValue} ${unit}` : displayValue;
    };

    return (
        <>
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Peso padrón</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={
                            hasStandardWeight
                                ? formatWeight(
                                      transportationOrder.standard_weight_value,
                                      transportationOrder.standard_weight_unit
                                  ) || 'No definido'
                                : 'No aplica'
                        }
                    />
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Límite inferior</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={
                            hasStandardWeight
                                ? formatWeight(
                                      transportationOrder.standard_weight_lower_limit,
                                      transportationOrder.standard_weight_lower_limit_unit
                                  ) || 'No definido'
                                : 'No aplica'
                        }
                    />
                </div>
            </div>
        </>
    );
};

export default TransportationOrderBillingTab;
